import { Box, Chip, ChipProps, Stack } from '@mui/material';
import { CustomCellProps } from 'components/common/grid/';
import LinkCell from './LinkCell';

interface LinkTag {
    text: string;
    color?: ChipProps['color'];
}

// A link followed by its status tags (pill-shaped, Figma 242-8446); the link ellipsizes, the tags never do.
export default function LinkTagsCell({ tags = [], ...linkProps }: CustomCellProps & { tags?: LinkTag[] }) {
    return (
        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ minWidth: 0 }}>
            <Box sx={{ display: 'flex', minWidth: 0 }}>
                <LinkCell {...linkProps} />
            </Box>
            {tags.map((tag) => (
                <Chip
                    key={tag.text}
                    label={tag.text}
                    variant="tag"
                    color={tag.color ?? 'default'}
                    sx={{ borderRadius: '10px', flexShrink: 0 }}
                />
            ))}
        </Stack>
    );
}
